/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 2618726e940e
 */

import * as z from "zod";
import { TriggerInfo, TriggerInfo$zodSchema } from "./triggerinfo.js";

/**
 * List response for triggers.
 */
export type TriggerListResponse = {
  triggers: Array<TriggerInfo>;
  total: number;
};

export const TriggerListResponse$zodSchema: z.ZodType<TriggerListResponse> = z
  .object({
    total: z.int().describe("Total number of triggers."),
    triggers: z.array(TriggerInfo$zodSchema).describe(
      "List of trigger objects.",
    ),
  }).describe("List response for triggers.");
